import { useState, useEffect } from 'react';

/**
 * Custom hook for debounced search functionality
 * @param {string} initialValue - Initial search value
 * @param {number} delay - Debounce delay in milliseconds (default: 500)
 * @returns {object} - { searchValue, debouncedValue, setSearchValue }
 */
export const useDebouncedSearch = (initialValue = '', delay = 500) => {
  const [searchValue, setSearchValue] = useState(initialValue);
  const [debouncedValue, setDebouncedValue] = useState(initialValue);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(searchValue);
    }, delay);

    // Cleanup timeout if searchValue changes
    return () => {
      clearTimeout(handler);
    };
  }, [searchValue, delay]);

  return {
    searchValue,
    debouncedValue,
    setSearchValue,
  };
};
